import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import pulseTracker from '@finn-no/pulse-sdk';

function Button({
    url,
    isAdOwner,
    onClick,
    unknownDisableReason,
    buttonVariant,
    showError,
    disabled,
}) {
    return isAdOwner || disabled ? (
        <div>
            <button
                type="button"
                disabled={disabled}
                title={unknownDisableReason ? 'En feil har oppstått' : null}
                className={
                    buttonVariant === 'SECONDARY'
                        ? 'button u-size1of1 u-mb8'
                        : 'button button--cta u-size1of1 u-mb8'
                }
                onClick={onClick}
            >
                Send melding
            </button>
            <p
                className={`${showError ? 'u-d1 u-cherry' : 'hidden'}`}
                id="send-message-own-ad-error-msg"
            >
                Oi sann! Du kan ikke sende melding til deg selv.
            </p>
        </div>
    ) : (
        <div>
            <a
                rel="nofollow"
                href={url}
                className={
                    buttonVariant === 'SECONDARY'
                        ? 'button u-size1of1'
                        : 'button button--cta u-size1of1'
                }
                onClick={onClick}
            >
                Send melding
            </a>
        </div>
    );
}

Button.propTypes = {
    url: PropTypes.string.isRequired,
    isAdOwner: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    unknownDisableReason: PropTypes.bool.isRequired,
    buttonVariant: PropTypes.string.isRequired,
    showError: PropTypes.string.isRequired,
    disabled: PropTypes.string.isRequired,
};

export default function ButtonWithTracking({
    url,
    isAdOwner,
    unknownDisableReason,
    adId,
    buttonVariant,
    loginId,
    disabled,
}) {
    const [showError, setShowError] = useState(false);
    useEffect(() => {
        setShowError(JSON.parse(window.localStorage.getItem('showError')));
        window.localStorage.removeItem('showError');
    }, []);

    useEffect(() => {
        if (!loginId) {
            window.localStorage.setItem('showError', showError);
        }
    }, [showError]);

    const trackButtonClick = () => {
        setShowError(true);
        // Not calling the tracker when the user is the ad owner.
        if (!isAdOwner) {
            pulseTracker.trackEvent({
                type: 'Click',
                intent: 'Create',
                name: 'Send message',
                object: {
                    id: 'sendMessageButton',
                    type: 'UIElement',
                    elementType: 'Button',
                    items: [
                        {
                            type: 'ClassifiedAd',
                            id: adId,
                            contentId: adId,
                            name: 'n/a',
                            category: 'n/a',
                            hasExtendedProfile: 'false',
                        },
                    ],
                    page: {
                        type: 'ClassifiedAd',
                    },
                },
                target: {
                    id: 'id',
                    type: 'Message',
                },
            });
        }
    };
    return (
        <Button
            url={url}
            isAdOwner={isAdOwner}
            onClick={trackButtonClick}
            unknownDisableReason={unknownDisableReason}
            buttonVariant={buttonVariant}
            showError={showError}
            loginId={loginId}
            disabled={disabled}
        />
    );
}

ButtonWithTracking.defaultProps = {
    isAdOwner: false,
    url: '',
    unknownDisableReason: false,
    adId: null,
    buttonVariant: 'PRIMARY',
    loginId: null,
    disabled: false,
};

ButtonWithTracking.propTypes = {
    isAdOwner: PropTypes.bool,
    url: PropTypes.string,
    unknownDisableReason: PropTypes.bool,
    adId: PropTypes.string,
    buttonVariant: PropTypes.string,
    loginId: PropTypes.number,
    disabled: PropTypes.bool,
};
